module.exports = __webpack_public_path__ + "img/octopus.32a5b085.png";